/**
 * @file 分账户数据
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';
import { observer } from 'mobx-react';
import { Table, Column, Empty, Loading } from '@tencent/spaui';

import { currencyFormatV2 } from '@/pages/agency/utils/format';
import TipIcon from '@/common-components/tip-icon';

import HomeItem from '../home-item';
import store from '../../store';

import './index.scoped.less';

const CardCostSummary: React.FC<any> = observer((props) => {
  const { title, schema } = props;
  const { accountListData } = store;

  const columnRender = (type: string, name: string, value: any, data: any) => {
    if (type === 'head') {
      if (data.props.tip) {
        return <TipIcon value={value} overlayTriggerProps={{ alignment: 'right' }}>{data.props.tip}</TipIcon>;
      }
    } else if (type === 'data') {
      switch (name) {
        case 'agency_uid': {
          const { agency_uid, spid, remark } = data;
          if (remark) {
            return remark;
          }
          if (spid) {
            return `SPID:${spid}`;
          }
          return `UID:${agency_uid}`;
        }
        case 'total_cost':
        case 'total_cost_yesterday':
        case 'balance':
          return currencyFormatV2(value, true);
        case 'total_advertiser':
        case 'total_advertiser_yesterday':
          return currencyFormatV2(value, false);
      }
    }
    return value;
  };

  return (
    <HomeItem
      title={title}
    >
      <div className="card-cost-detail">
        <Table
          data={accountListData}
          bordered={false}
          fixedHeight={160}
          EmptyComponent={() => (
            <Loading />
          )}
        >
          {
            _.get(schema, 'columns', []).map((v: any) => {
              const { name, title, align, tip } = v;
              return (
                <Column
                  key={name}
                  name={name}
                  align={align}
                  tip={tip}
                  render={columnRender}
                >
                  {title}
                </Column>
              );
            })
          }
        </Table>
      </div>
    </HomeItem>
  );
});

export default CardCostSummary;
